/**
 * sl-sbpf.1: Frontend facade for the canonical component-type list.
 *
 * The canonical definition lives in @streamlain/view-config so the
 * custom-app CSS contract, schema validation, and both renderers
 * derive from one list. Local const bindings keep the established
 * frontend-core import path visible to webpack's strict export analysis.
 */
import type { ViewComponentType } from '@streamlain/view-config';
import * as ViewConfig from '@streamlain/view-config';

export const VIEW_COMPONENT_TYPES = ViewConfig.VIEW_COMPONENT_TYPES;
export const VIEW_COMPONENT_TYPE_VALUES = ViewConfig.VIEW_COMPONENT_TYPE_VALUES;
export const isViewComponentType = ViewConfig.isViewComponentType;
export type { ViewComponentType };
